module.exports = __webpack_public_path__ + "img/QQ.9f2a50c1.svg";